import { render, staticRenderFns } from "./PopUpDataTable.vue?vue&type=template&id=eaab4210"
import script from "./PopUpDataTable.vue?vue&type=script&lang=js"
export * from "./PopUpDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports